import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { HiClock, HiGift, HiMinusCircle } from "react-icons/hi";
import useAuth from "../../hooks/useAuth";
import { useGetTrialStatus } from "../../hooks/promoCode";

const ActiveTrialBanner: React.FC<{ className?: string }> = ({
  className = "",
}) => {
  const { t } = useTranslation();
  const { user, customer_identification } = useAuth();

  const { data: trialStatus } = useGetTrialStatus(
    customer_identification,
    user.entity_identification
  );

  if (!trialStatus?.data?.has_active_trial || !trialStatus.data.trial_info) {
    return null;
  }

  const trialInfo = trialStatus.data.trial_info;

  return (
    <div className={`w-full ${className}`}>
      <div className="bg-white rounded-lg border border-gray-200 p-5">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
            <HiGift className="w-5 h-5 text-blue-600" />
          </div>
          <div className="flex-1 space-y-3 min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <span className="px-2.5 py-0.5 rounded-full bg-blue-50 border border-blue-200 text-blue-700 text-xs font-semibold font-figtree">
                {trialInfo.code}
              </span>
              <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-amber-50 border border-amber-200 text-amber-700 text-xs font-semibold font-figtree">
                <HiClock size={14} className="flex-shrink-0" />
                {t("dashboard.trialOffer.daysLeft", {
                  count: trialInfo.days_left,
                })}
              </span>
            </div>

            <p className="text-sm text-gray-600 font-figtree">
              {t("dashboard.billings.promoTrialAccess")}
            </p>

            <div className="flex flex-wrap gap-2">
              {[
                t("dashboard.billings.promoRestriction1"),
                t("dashboard.billings.promoRestriction2"),
                t("dashboard.billings.promoRestriction6"),
                t("dashboard.billings.promoRestriction3"),
                t("dashboard.billings.promoRestriction4"),
                t("dashboard.billings.promoRestriction5"),
              ].map((restriction, index) => (
                <span
                  key={index}
                  className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-gray-50 text-gray-600 rounded-lg text-xs font-medium font-figtree border border-gray-200"
                >
                  <HiMinusCircle
                    size={14}
                    className="text-gray-400 flex-shrink-0"
                  />
                  {restriction}
                </span>
              ))}
            </div>

            <p className="text-xs text-gray-500 font-figtree">
              {t("dashboard.billings.promoSupportNote")}{" "}
              <Link
                to="/control-panel/support?requestType=feature_request"
                className="font-medium text-blue-600 hover:text-blue-800"
              >
                {t("dashboard.billings.promoSupportCta")}
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActiveTrialBanner;
